module.exports = __webpack_public_path__ + "img/icon_dean_home_bg_card_2.1221d273.png";